import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import { SaveOutlined } from "@ant-design/icons";

import Sidebar from "../Patient/ApplicationFormEditor/sidebar";
import { GRAY_300 } from "../../constant/colors";
import { ApplicationForm } from "../Patient/ApplicationFormEditor/ApplicationForm";
import { HeaderSection } from "./HeaderSection";
import { updateJson } from "./updateJson";
import SBItemsHelper from "../Patient/ApplicationFormEditor/utils/sidebarItemsHelper";
import { useTranslation } from "react-i18next";

const form_id = "online-wizard-form";

export const OnlinePreview = ({ sections, setJson }) => {
  const [shouldUpdateJson, setShouldUpdateJson] = useState(false);
  const [sectionsWithErrors, setSectionsWithErrors] = useState([]);
  const { t } = useTranslation();
  const sidebarItems = SBItemsHelper.generateSidebarConfig(t, form_id, {
    formSections: Object.values(sections)
  });
  const [form] = Form.useForm();
  const onErrors = (validationErrors) => {
    if (!validationErrors?.length) {
      setSectionsWithErrors([]);
      return;
    }
    const errorFields = validationErrors.map((fieldInfo) => fieldInfo.name[0]);
    const uniqueErrorFields = [...new Set(errorFields)];

    const sectionsWithErrors = [];
    sidebarItems.forEach(({ validationFields, key }) => {
      if (uniqueErrorFields.some((errorField) => validationFields.includes(errorField))) {
        sectionsWithErrors.push(key);
      }
    });

    setSectionsWithErrors(sectionsWithErrors);
  };

  return (
    <div>
      <Row style={{ justifyContent: "center" }}>
        <Button
          type="primary"
          onClick={() => updateJson(sections, setJson)}
          icon={<SaveOutlined />}
          style={{ margin: 5 }}
        >
          Update JSON {shouldUpdateJson ? "*" : ""}
        </Button>
      </Row>
      <Row style={{ minHeight: "75vh" }}>
        <Col span={4} style={{ paddingRight: "0.5em", borderRight: `1px solid ${GRAY_300}`, paddingTop: "1em" }}>
          <Sidebar
            sectionsWithErrors={sectionsWithErrors}
            sidebarItems={sidebarItems}
            activeFormSection={sidebarItems?.[0]?.href}
            formId={form_id}
            disabled={false}
          />
        </Col>
        <Col span={20}>
          <ApplicationForm form={form} onErrors={onErrors} formId={form_id}>
            {<HeaderSection sections={sections} setShouldUpdateJson={setShouldUpdateJson} form={form} />}
          </ApplicationForm>
        </Col>
      </Row>
    </div>
  );
};
